var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonPages',{class:['terms-page'],attrs:{"id":"terms","titlePrefix":_vm.pageMetaTitle,"metaDescription":_vm.pageMetaDescription}},[_c('LegalContentLayout',{attrs:{"title":"Terms of Service"}},[_c('div',{staticClass:"legal-richtext"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.termsBody)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }